import { Link } from "react-router-dom";
import { UsersRound, Building2 } from "lucide-react";
import { PageHeader } from "@/components/control/PageHeader";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Loadable, Empty, Status, useLoad, fmt } from "@/components/control/kit";
import { categoryLabel } from "@/components/control/activityFields";

export default function Groups() {
  const st = useLoad("/manage/groups");
  return (
    <div>
      <PageHeader title="Kreise & Gruppen" subtitle="Regeln, Verantwortung und Pausen der Kreise verwalten." icon={UsersRound} />
      <Loadable state={st}>
        {(d) => (d.groups.length === 0 ? <Empty /> : (
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="groups-grid">
            {d.groups.map((g) => (
              <Link key={g.id} to={`/kreise-gruppen/${g.id}`} data-testid={`group-card-${g.id}`} className="rounded-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-magenta">
                <Card className="h-full border-border/70 transition-shadow duration-200 hover:shadow-md">
                  <CardHeader className="pb-3">
                    <div className="flex items-start justify-between gap-2">
                      <CardTitle className="text-lg text-brand-purple">{g.name_de}</CardTitle>
                      <Status value={g.status} />
                    </div>
                    <p className="text-xs text-muted-foreground">{categoryLabel(g.category_key)}</p>
                  </CardHeader>
                  <CardContent className="space-y-1.5 text-sm text-muted-foreground">
                    <p className="flex items-center gap-2"><Building2 className="h-4 w-4" /> {g.organization || "–"}</p>
                    <p><span className="text-xl font-bold text-brand-magenta">{g.members_count ?? 0}</span> Mitglieder</p>
                    {g.paused_until && <p className="text-orange-700">Pausiert bis {fmt(g.paused_until)}</p>}
                    {g.pending_rules && <p className="text-orange-700">Regeländerung wartet auf Freigabe</p>}
                    {g.pending_requests > 0 && <p className="text-orange-700" data-testid={`group-pending-${g.id}`}>{g.pending_requests} Aufnahmeanfrage(n) offen</p>}
                  </CardContent>
                </Card>
              </Link>
            ))}
          </div>
        ))}
      </Loadable>
    </div>
  );
}
